// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__MWyBg","inputDescription":"styles_inputDescription__2PY6G"};